/**
 * Task view stays mounted across task-id changes (same route component).
 * Do not render task-scoped forms until the loaded task matches the route,
 * otherwise Formik / react-hook-form state from the previous task can be
 * submitted onto the newly selected task.
 */
export function isTaskViewDataReady<TTask extends { id: string }>(
  task: TTask | null | undefined,
  taskId: string | undefined
): task is TTask {
  return Boolean(task && taskId && String(task.id) === String(taskId));
}
